import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Grid } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion'
import { ContextOperacionNuevo, ContextOperacionNuevoType } from '../../NuevoSistema'
import { HttpNOTES } from './api/httpNOTES'
import { SeccionNuevoNOTESDatosOperacion } from './components/SeccionNuevoNOTESDatosOperacion'
import { OperacionNOTESInsert, schemaOperacionNOTESInsert } from './types/dto'
import { OperacionNOTESFields } from './types/fields'
import SeccionNuevoNOTESDatosSecciones from './components/SeccionNuevoNOTESDatosSecciones'
import SeccionNuevoNOTESOtrosParametros from './components/SeccionNuevoNOTESOtrosParametros '
import SeccionNuevoNOTESArchivo from './components/SeccionNuevoNOTESArchivo '
import { FilePutFields } from '../../api/file-fields'

interface NuevoSistemaNOTESProps {
  codSistemaPrincipal: number
}

const NuevoSistemaNOTES = ({ codSistemaPrincipal }: NuevoSistemaNOTESProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  const formMethods = useForm<OperacionNOTESInsert>({
    resolver: zodResolver(schemaOperacionNOTESInsert),
    defaultValues: {
      [OperacionNOTESFields.FechaSolicitud]: new Date(),
      [OperacionNOTESFields.CodPais]: codSistemaPrincipal,
      [OperacionNOTESFields.Parametros]: []
    }
  })

  const tieneGrafico = useWatch({
    control: formMethods.control,
    name: FilePutFields.File
  })


  const handleCrearOperacion = useCallback(
    (data: OperacionNOTESInsert) => {
      const dataAEnviar = {
        ...data,
        [OperacionNOTESFields.NombrePais]: null,
        [OperacionNOTESFields.FechaEmision]: new Date()
      };

      submitOperacion(dataAEnviar, {
        apiCall: HttpNOTES.post,
        codSistemaPrincipal,
        requireConfirmation: !tieneGrafico,
        confirmationMessage: "¿Está seguro que desea crear esta operación sin gráfico de subyacentes?"
      });
    },
    [codSistemaPrincipal, submitOperacion, tieneGrafico]
  );

  useEffect(() => {
    setSendPromise(() => 
      formMethods.handleSubmit(
        handleCrearOperacion, 
        (errors) => console.log("Falló la validación. Errores:", errors)
      )
    )
  }, [formMethods, handleCrearOperacion, setSendPromise])


  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoNOTESDatosOperacion formMethods={formMethods} codSistema={codSistema} codPais={codSistemaPrincipal} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoNOTESDatosSecciones formMethods={formMethods} codPais={codSistemaPrincipal} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoNOTESOtrosParametros formMethods={formMethods} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoNOTESArchivo formMethods={formMethods}/>
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaNOTES
